<div class="report-info">
  <div class="row mb-2">
    <div class="col-md-3">
      <label class="control-label fw-bold">{{ 'i18n.shared.fields.firstname' | translate }}</label>
      <div>{{ report.user?.firstname }}</div>
    </div>
    <div class="col-md-3">
      <label class="control-label fw-bold">{{ 'i18n.shared.fields.lastname' | translate }}</label>
      <div>{{ report.user?.lastname }}</div>
    </div>
    <div class="col-md-3">
      <label class="control-label fw-bold">{{ 'i18n.domain.problem-report-administration.overview.fields.platform' | translate }}</label>
      <div>{{ report.platform }}</div>
    </div>
    <div class="col-md-3">
      <label class="control-label fw-bold">{{ 'i18n.domain.problem-report-administration.overview.fields.created-on' | translate }}</label>
      <div>{{ formatDateTime(report.createdOn) }}</div>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-md-3">
      <label class="control-label fw-bold">{{ 'i18n.domain.problem-report-administration.overview.fields.model' | translate }}</label>
      <div>{{ report.model }}</div>
    </div>
    <div class="col-md-3">
      <label class="control-label fw-bold">{{ 'i18n.domain.problem-report-administration.overview.fields.manufacturer' | translate }}</label>
      <div>{{ report.manufacturer }}</div>
    </div>
    <div class="col-md-3">
      <label class="control-label fw-bold">{{ 'i18n.domain.problem-report-administration.overview.fields.device-name' | translate }}</label>
      <div>{{ report.deviceName }}</div>
    </div>
    <div class="col-md-3">
      <label class="control-label fw-bold">{{ 'i18n.domain.problem-report-administration.overview.fields.version-string' | translate }}</label>
      <div>{{ report.versionString }}</div>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-md-3">
      <label class="control-label fw-bold">{{ 'i18n.domain.problem-report-administration.overview.fields.idiom' | translate }}</label>
      <div>{{ report.idiom }}</div>
    </div>
    <div class="col-md-3">
      <label class="control-label fw-bold">{{ 'i18n.domain.problem-report-administration.overview.fields.device-type' | translate }}</label>
      <div>{{ report.deviceType }}</div>
    </div>
    <div class="col-md-3">
      <label class="control-label fw-bold">{{ 'i18n.domain.problem-report-administration.overview.fields.user-id' | translate }}</label>
      <div>{{ report.userId }}</div>
    </div>
    <div class="col-md-3">
      <label class="control-label fw-bold">{{ 'i18n.domain.problem-report-administration.overview.fields.origin' | translate }}</label>
      <div>{{ ProblemReportOrigin[report.origin] }}</div>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-md-12">
      <label class="control-label fw-bold">{{ 'i18n.domain.problem-report-administration.overview.fields.problem-message' | translate }}</label>
      <div class="problem-message-text">{{ report.problemMessage }}</div>
    </div>
  </div>
</div>

<h6 class="mt-3 mb-2">{{ 'i18n.domain.problem-report-administration.detail.logs-title' | translate }}</h6>

<form [formGroup]="filterForm" class="logs-filter-bar mb-2">
  <div class="d-flex align-items-center flex-wrap gap-2">
    <div class="d-flex align-items-center">
      <label class="control-label me-1 text-nowrap">{{ 'i18n.domain.problem-report-administration.detail.filter.level' | translate }}:</label>
      <app-enum-drop-down-list
        formControlName="level"
        [showClearButton]="true"
        [enumType]="LogEventLevel"
        width="150"
        baseTranslationString="i18n.domain.problem-report-administration.detail.filter.log-levels.">
      </app-enum-drop-down-list>
    </div>
    <div class="d-flex align-items-center">
      <label class="control-label me-1 text-nowrap">{{ 'i18n.domain.problem-report-administration.detail.filter.from' | translate }}:</label>
      <ejs-datetimepicker
        formControlName="startDate"
        format="dd.MM.yyyy HH:mm"
        width="190"
        [showClearButton]="true">
      </ejs-datetimepicker>
    </div>
    <div class="d-flex align-items-center">
      <label class="control-label me-1 text-nowrap">{{ 'i18n.domain.problem-report-administration.detail.filter.to' | translate }}:</label>
      <ejs-datetimepicker
        formControlName="endDate"
        format="dd.MM.yyyy HH:mm"
        width="190"
        [showClearButton]="true">
      </ejs-datetimepicker>
    </div>
    <div class="d-flex align-items-center flex-grow-1">
      <label class="control-label me-1 text-nowrap">{{ 'i18n.domain.problem-report-administration.detail.filter.search' | translate }}:</label>
      <input type="text" class="form-control form-control-sm" formControlName="searchText"
        placeholder="{{ 'i18n.domain.problem-report-administration.detail.filter.search-placeholder' | translate }}">
    </div>
  </div>
</form>

<ejs-grid #logsGrid
  width="100%"
  rowHeight="38"
  [dataSource]="logsData"
  [allowSorting]="true"
  [allowFiltering]="true"
  [filterSettings]="logsFilterSettings"
  [allowPaging]="true"
  [pageSettings]="logsPageSettings"
  [allowResizing]="true">
  <e-columns>
    <e-column field="id" [visible]="false" headerText="ID" [isPrimaryKey]="true" width="60"></e-column>
    <e-column field="timestamp" headerText="{{ 'i18n.domain.problem-report-administration.detail.fields.timestamp' | translate }}" type="date" format="dd.MM.yyyy HH:mm:ss" width="170"></e-column>
    <e-column field="level" headerText="{{ 'i18n.domain.problem-report-administration.detail.fields.level' | translate }}" width="100">
      <ng-template #template let-data>
        <span [class]="getLevelCssClass(data.level)">{{ formatLogLevel(data.level) }}</span>
      </ng-template>
    </e-column>
    <e-column field="threadId" headerText="{{ 'i18n.domain.problem-report-administration.detail.fields.thread-id' | translate }}" width="100"></e-column>
    <e-column field="message" headerText="{{ 'i18n.domain.problem-report-administration.detail.fields.message' | translate }}" clipMode="EllipsisWithTooltip" width="400">
      <ng-template #template let-data>
        <span class="copyable-text" [title]="data.message" (click)="copyToClipboard(data.message)">{{ data.message }}</span>
      </ng-template>
    </e-column>
    <e-column field="exception" headerText="{{ 'i18n.domain.problem-report-administration.detail.fields.exception' | translate }}" clipMode="EllipsisWithTooltip" width="400">
      <ng-template #template let-data>
        <span class="copyable-text" [title]="data.exception" (click)="copyToClipboard(data.exception)">{{ data.exception }}</span>
      </ng-template>
    </e-column>
  </e-columns>
</ejs-grid>
